import { autoinject } from 'aurelia-framework';
import { ComponentBase, Sorting, SortDirection } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { openProviderSummary } from 'app/cd/components/summary/provider/provider-summary';
import { openMemberSummary } from 'app/cd/components/summary/member/member-summary';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { localSort } from 'app/shared/lib/sorting';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class HouseholdMembershipsGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.array
    protected memberships: CD.HouseholdMembership[] = [];
    private sorting: Sorting = new Sorting();
    protected defaultSorting = new Sorting();

    protected showProviderSummaryLink: boolean = false;
    protected openProviderSummary = openProviderSummary;
    protected showMemberSummaryLink: boolean = false;
    protected openMemberSummary = openMemberSummary;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);

        this.defaultSorting.entries = [
            {
                reference: 'id',
                direction: SortDirection.Ascending
            }
        ];

        this.checkPermissions();
    }


    ////****************** Events ***************************************************////
    protected applySort(event: SortChangeEvent, memberships: (CD.HouseholdMembership)[]): void {
        const { property, direction } = event.detail;
        const { sorting, defaultSorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }

        // if no sorting entries specified, use default sorting
        localSort(memberships, sorting.entries.length > 0 ? sorting : defaultSorting);
    }

    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        this.showProviderSummaryLink = this.accountContext.hasRouteAccess('cd.provider.summary');
        this.showMemberSummaryLink = this.accountContext.hasRouteAccess('cd.member.summary');
    }

    ////****************** Service Calls ********************************************////


}
